import React from 'react';
import styled from 'styled-components';

const H1 = styled.h1`
  color: ${(props) => props.theme.colors.darkblue};
  font-size: 24px;
  font-weight: 700;
  margin: 5px 0;
  padding: 0;
`;

const H2 = styled.h2`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.greyblue};
`;

function Header() {
  return (
    <div>
      <H1>{config.headline}</H1>
      <H2>{config.subline}</H2>
    </div>
  );
}

export default Header;
